var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14118_79015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56641 1.93213C9.32641 1.93213 11.5664 4.17213 11.5664 6.93213C11.5664 9.69213 9.32641 11.9321 6.56641 11.9321C3.80641 11.9321 1.56641 9.69213 1.56641 6.93213C1.56641 4.17213 3.80641 1.93213 6.56641 1.93213ZM6.56641 10.9321C8.77641 10.9321 10.5664 9.14213 10.5664 6.93213C10.5664 4.72213 8.77641 2.93213 6.56641 2.93213C4.35641 2.93213 2.56641 4.72213 2.56641 6.93213C2.56641 9.14213 4.35641 10.9321 6.56641 10.9321ZM8.33441 4.45713L9.04141 5.16413L6.56641 7.63913L5.85941 6.93213L8.33441 4.45713Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14118_79015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.566406 0.932129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeImg);
export default __webpack_public_path__ + "static/media/timeImg.3278b6a4a0cfe3f7f718bf4e7e99a54d.svg";
export { ForwardRef as ReactComponent };